import { render, staticRenderFns, recyclableRender, components } from "./mp-html.vue?vue&type=template&id=0cfd6ca1&"
var renderjs
import script from "./mp-html.vue?vue&type=script&lang=js&"
export * from "./mp-html.vue?vue&type=script&lang=js&"
import style0 from "./mp-html.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/mp-html/components/mp-html/mp-html.vue"
export default component.exports